<template>
    <div class="pe_play-playpause" @click="toggle">
      <svg viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5" r="4" :fill="pauseBGColor" stroke="#000000" stroke-width="0.5" />
        <rect x="3.2" y="2.9" width="0.9" height="4" fill="#000000" />
        <rect x="5.7" y="2.9" width="0.9" height="4" fill="#000000" />
      </svg>

      
        <!-- play = &#9654; and Pause = &#9724;-->
       <!-- {{ playing ? 'll' : '>' }} -->
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex'
  export default {
    data() {
      return {
        playing: true
      }
    },
    methods: {
      toggle() {
        this.playing = false //!this.playing
        this.$emit('play-pause', this.playing)
      }
    },
    computed: {
      ...mapState({
        gameType: state => state.game.type,
      }),

      pauseBGColor(){
        
        return this.gameType === 'sudoku' ? '#ffedc2' :
              this.gameType === 'crossword' ? '#fabeb9':  
              this.gameType === 'codecracker' ? '#c6fbe3' :
              this.gameType === 'wordsearch' ? '#ebbdef' : '#ffffff'
      },
    }
  }
  </script>
  
  <style scoped lang="scss">
  .pe_play-playpause {
  width: 25px;
  height: 25px;
  margin-right: 0.8em;
  cursor: pointer;
  display: inline-flex;
  height: 100%;
}


.playing path:first-of-type,
.playing g {
  display: none;
}
.playing path:last-of-type {
  display: block;
}
</style>
